import { render } from "./PagosList.vue?vue&type=template&id=2440dbda&scoped=true"
import script from "./PagosList.vue?vue&type=script&lang=js"
export * from "./PagosList.vue?vue&type=script&lang=js"

import "./PagosList.vue?vue&type=style&index=0&id=2440dbda&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2440dbda"]])

export default __exports__